import { Component, ElementRef, HostListener, Inject, OnDestroy, PLATFORM_ID} from '@angular/core';
import { Observable,  Subject } from 'rxjs';
import { environment } from '~env/environment';
import { MmPopoverRef } from '~shared/modules/popover/popover.module';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  ACCEPT_COOKIES_URL_QUERY,
  COMPASS_COOKIE_DISCLAIMER_CLASS,
  COMPASS_COOKIE_DISCLAIMER_TAG,
  COOKIE_BANNER_OVERLAY_CLASS
} from '~shared/modules/cookie-consent/constants/cookie-consent.constant';
import { IdentityService } from '~core/modules/identity/services/identity.service';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { CookieService } from '~shared/services/cookie.service';
import { createCookieExpiration } from '~shared/modules/price-type-toggler/utils/price-type-cookies.util';
import { PRICE_TYPE_EXPLANATION_COOKIE_NAME } from '~shared/modules/price-type-toggler/constants/cookie-name.constant';

@Component({
  selector: 'app-price-type-explanation-popup',
  templateUrl: './price-type-explanation-popup.component.html',
  styleUrls: ['./price-type-explanation-popup.component.scss']
})
export class PriceTypeExplanationPopupComponent implements OnDestroy {
  confirmationImgUrl = `${environment.cdnBaseUrl()}/images/price-type-confirmation.svg`;
  isLoggedIn$: Observable<boolean>;
  authState$ = this.authIdamStateService.state$;
  public PendingState = AuthorizationStateType.Pending;
  private destroySubject$ = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private identityService: IdentityService,
    @Inject(DOCUMENT) private document: Document,
    private priceTypeExplanationRef: MmPopoverRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authIdamStateService: AuthorizationIdamStateService,
    private cookieService: CookieService,
  ) {
    this.isLoggedIn$ = this.identityService.isLoggedIn();
  }

  closePriceTypeExplanation() {
    if (isPlatformBrowser(this.platformId)) {
      const expires = createCookieExpiration();
      this.cookieService.set(PRICE_TYPE_EXPLANATION_COOKIE_NAME, 'false', expires, '/');
      this.priceTypeExplanationRef.close();
    }
  }

  checkNewCookieDisclaimer() {
    if (isPlatformBrowser(this.platformId)) {
      const isNewCookiesDisclaimerAccepted = window.location.href.includes(ACCEPT_COOKIES_URL_QUERY);
      const isNewCookieDisclaimerVisible = this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG)
        .classList.contains(COMPASS_COOKIE_DISCLAIMER_CLASS);
      if (isNewCookiesDisclaimerAccepted && isNewCookieDisclaimerVisible) {
        this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG).classList.remove(COMPASS_COOKIE_DISCLAIMER_CLASS);
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    const onExplanationPopupClicked = this.elementRef.nativeElement.contains(event.target);
    const isCookieOverlayVisible = this.document.body.classList.contains(COOKIE_BANNER_OVERLAY_CLASS);
    const isNewCookieDisclaimerVisible = this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG)
      .classList.contains(COMPASS_COOKIE_DISCLAIMER_CLASS);

    if(!onExplanationPopupClicked && !isCookieOverlayVisible && !isNewCookieDisclaimerVisible) {
      this.closePriceTypeExplanation();
    }

    this.checkNewCookieDisclaimer();
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
